import { render, staticRenderFns } from "./getSystem.vue?vue&type=template&id=672c2170&scoped=true&"
import script from "./getSystem.vue?vue&type=script&lang=js&"
export * from "./getSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c2170",
  null
  
)

export default component.exports